export enum LorenAlarmsFilter {
  ASSET_IDS = "assetIds",
  ASSET_GROUP_IDS = "assetGroupIds",
  IS_CRITICAL = "isCritical",
  STATUS = "status",
  START_TIME = "startTime",
  END_TIME = "endTime",
  PROCESSED_TIME = "processedTime",
  ASSET_METERING_TYPE = "assetMeteringType",
}
